// extracted by mini-css-extract-plugin
module.exports = {"skeletonCard":"SkeletonCard_skeletonCard__yOLqm","pulse":"SkeletonCard_pulse__D5OxR"};